import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Filters from "./Filters";
import FilteredTable from "./FilteredTable";
import CustomButton from "./Button2";
import TableControls from "./TableControls"; // ✅ Import
import "./DashboardLayout.css";

const DashboardLayout = ({ onLogout }) => {
  const [filteredData, setFilteredData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");

  // ✅ Move activeView here
  const [activeView, setActiveView] = useState("BR");
  const [loading, setLoading] = useState(false);

  // ✅ Move refs here
  const dayWiseTableRef = useRef(null);
  const weeklyTableRef = useRef(null);
  const monthlyTableRef = useRef(null);

  useEffect(() => {
    const today = new Date();
    today.setHours(6, 0, 0, 0);

    const formattedDate = today.toISOString().slice(0, 16).replace("T", " ");
    setLastUpdated(`Last data updated: ${formattedDate}`);
  }, []);

  const handleViewChange = (view) => {
    setLoading(true);
    setActiveView(view);
    setTimeout(() => setLoading(false), 500);
  };

  const scrollToTable = (ref) => {
    ref?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="dashboard-layout">
      <Header onLogout={onLogout} />

      <nav className="header-nav-v2">
        <CustomButton />
      </nav>

      <Filters setFilteredData={setFilteredData} />

      {/* ✅ Add Controls Below Filters */}
      <div className="controls-row">
  <TableControls
    activeView={activeView}
    handleViewChange={handleViewChange}
    scrollToTable={scrollToTable}
    dayWiseRef={dayWiseTableRef}
    weeklyRef={weeklyTableRef}
    monthlyRef={monthlyTableRef}
  />

  <div className="last-updated">{lastUpdated}</div>
</div>


      <main className="dashboard-content">
        <FilteredTable
          data={filteredData}
          activeView={activeView}
          loading={loading}
          dayWiseRef={dayWiseTableRef}
          weeklyRef={weeklyTableRef}
          monthlyRef={monthlyTableRef}
        />
        
      </main>
    </div>
  );
};

export default DashboardLayout;
